import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "row full-width"
}
const _hoisted_2 = {
  key: 2,
  class: "row full-width"
}
const _hoisted_3 = {
  key: 1,
  class: "row full-width no-wrap"
}
const _hoisted_4 = {
  key: 2,
  class: "row justify-left full-width"
}
const _hoisted_5 = {
  key: 2,
  class: "row no-wrap items-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_variable_display_item = _resolveComponent("variable-display-item")!
  const _component_date_range_display_item = _resolveComponent("date-range-display-item")!
  const _component_project_stage_display_item = _resolveComponent("project-stage-display-item")!
  const _component_storage_item_filter_wrapper = _resolveComponent("storage-item-filter-wrapper")!
  const _component_q_chip = _resolveComponent("q-chip")!
  const _component_q_toggle = _resolveComponent("q-toggle")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_native_input = _resolveComponent("native-input")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_btn = _resolveComponent("q-btn")!

  return (_openBlock(), _createElementBlock("div", {
    ref: "variable_display_target",
    class: _normalizeClass([{ 'row': _ctx.displayType === 'chip' }])
  }, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.theModel, (el, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: _ctx.getItemKey(el, index),
        ref_for: true,
        ref: (elem) => { _ctx.divs[index] = elem},
        class: _normalizeClass([{ 'col': _ctx.displayType !== 'chip' }, { 'var-dlst-item': _ctx.displayType === 'chip' }])
      }, [
        (_ctx.displayType === 'chip')
          ? (_openBlock(), _createBlock(_component_q_chip, {
              key: 0,
              color: "grey-7",
              dense: "",
              dark: "",
              removable: "",
              onRemove: ($event: any) => (_ctx.deleteItem(index))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", null, [
                  ([0, 1, 4, 9, 10].includes(_ctx.modelType))
                    ? (_openBlock(), _createBlock(_component_variable_display_item, {
                        key: 0,
                        modelValue: _ctx.theModel[index],
                        "onUpdate:modelValue": ($event: any) => ((_ctx.theModel[index]) = $event),
                        modelType: _ctx.modelType,
                        modelCategory: _ctx.modelCategory,
                        "compound-name": _ctx.linearNames[index],
                        "id-chain": _ctx.linearParents[index] ? _ctx.linkChains[index].slice(1) : _ctx.linkChains[index],
                        "parameter-options": _ctx.modelType === 4 ? (_ctx.linearParents[index] ? (_ctx.linearParents[index] as SelectionParameterFilterRecordSend).FieldFilters : _ctx.modelValue) : null,
                        "full-parameter-options": _ctx.fullParameterOptions,
                        "parent-element": _ctx.linearParents[index],
                        "role-options": _ctx.roleOptions
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "modelType", "modelCategory", "compound-name", "id-chain", "parameter-options", "full-parameter-options", "parent-element", "role-options"]))
                    : ([2,14].includes(_ctx.modelType))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                          _createVNode(_component_date_range_display_item, {
                            modelValue: _ctx.theModel[index],
                            "onUpdate:modelValue": ($event: any) => ((_ctx.theModel[index]) = $event),
                            modelType: 2
                          }, null, 8, ["modelValue", "onUpdate:modelValue"])
                        ]))
                      : (_ctx.modelType === 3)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createVNode(_component_project_stage_display_item, {
                              modelValue: _ctx.theModel[index],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.theModel[index]) = $event),
                              modelType: _ctx.modelType
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "modelType"])
                          ]))
                        : (_ctx.modelType === 12)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 3,
                              ref_for: true,
                              ref: (el) => { _ctx.triggerEls[index] = el },
                              class: "row full-width"
                            }, [
                              (_ctx.triggerEls && _ctx.triggerEls[index])
                                ? (_openBlock(), _createBlock(_component_storage_item_filter_wrapper, {
                                    key: 0,
                                    id: 'paramd'+index,
                                    modelValue: _ctx.theModel[index],
                                    "onUpdate:modelValue": ($event: any) => ((_ctx.theModel[index]) = $event),
                                    "root-param": _ctx.parameter_global,
                                    "show-clear-icon": !_ctx.isContainerEmpty(index),
                                    "trigger-el": _ctx.triggerEls[index]
                                  }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "root-param", "show-clear-icon", "trigger-el"]))
                                : _createCommentVNode("", true)
                            ], 512))
                          : _createCommentVNode("", true)
                ])
              ]),
              _: 2
            }, 1032, ["onRemove"]))
          : (_ctx.theModel[index].Descriptor || !_ctx.hasSelectedChildren(index))
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", {
                  class: _normalizeClass({ 'col': _ctx.modelType === 1 || _ctx.modelType === 4 })
                }, [
                  ([0, 1, 4, 9, 10].includes(_ctx.modelType))
                    ? (_openBlock(), _createBlock(_component_variable_display_item, {
                        key: 0,
                        modelValue: _ctx.theModel[index],
                        "onUpdate:modelValue": ($event: any) => ((_ctx.theModel[index]) = $event),
                        modelType: _ctx.modelType,
                        modelCategory: _ctx.modelCategory,
                        "role-options": _ctx.roleOptions,
                        "full-parameter-options": _ctx.fullParameterOptions,
                        "compound-name": _ctx.linearNames[index],
                        "id-chain": _ctx.linearParents[index] ? _ctx.linkChains[index].slice(1) : _ctx.linkChains[index],
                        "parameter-options": _ctx.modelType === 4 ? (_ctx.linearParents[index] ? (_ctx.linearParents[index] as SelectionParameterFilterRecordSend).FieldFilters : _ctx.modelValue) : null,
                        "parent-element": _ctx.linearParents[index],
                        onOnDeleteClick: ($event: any) => (_ctx.deleteItem(index))
                      }, null, 8, ["modelValue", "onUpdate:modelValue", "modelType", "modelCategory", "role-options", "full-parameter-options", "compound-name", "id-chain", "parameter-options", "parent-element", "onOnDeleteClick"]))
                    : (_openBlock(), _createElementBlock("div", {
                        key: 1,
                        ref_for: true,
                        ref: (el) => { _ctx.triggerEls[index] = el },
                        class: "row justify-left full-width no-wrap"
                      }, [
                        (![2,3,14].includes(_ctx.modelType) && _ctx.theModel[index].Positive !== undefined)
                          ? (_openBlock(), _createBlock(_component_q_toggle, {
                              key: 0,
                              modelValue: _ctx.theModel[index].Positive,
                              "onUpdate:modelValue": ($event: any) => ((_ctx.theModel[index].Positive) = $event),
                              class: _normalizeClass(`q-pa-none toggle-checkbox q-mr-none ${[3,12].includes(_ctx.modelType) ?'unset-items-center' : 'items-center'}`),
                              style: _normalizeStyle(`${[12].includes(_ctx.modelType) ?'margin-top: -2px;' : ''}`),
                              "checked-icon": "add",
                              color: "primary",
                              label: "",
                              size: "xs",
                              "unchecked-icon": "remove"
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "class", "style"]))
                          : _createCommentVNode("", true),
                        (_ctx.modelType === 12 && _ctx.triggerEls && _ctx.triggerEls[index])
                          ? (_openBlock(), _createBlock(_component_storage_item_filter_wrapper, {
                              key: 1,
                              id: 'param2d'+index,
                              modelValue: _ctx.theModel[index],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.theModel[index]) = $event),
                              "root-param": _ctx.parameter_global,
                              "show-clear-icon": !_ctx.isContainerEmpty(index),
                              "trigger-el": _ctx.triggerEls[index]
                            }, null, 8, ["id", "modelValue", "onUpdate:modelValue", "root-param", "show-clear-icon", "trigger-el"]))
                          : _createCommentVNode("", true)
                      ], 512)),
                  (_ctx.modelType !== 12)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        ([2,14].includes(_ctx.modelType))
                          ? (_openBlock(), _createBlock(_component_date_range_display_item, {
                              key: 0,
                              modelValue: _ctx.theModel[index],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.theModel[index]) = $event),
                              modelType: 2,
                              onOnDeleteClick: ($event: any) => (_ctx.deleteItem(index))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onOnDeleteClick"]))
                          : _createCommentVNode("", true),
                        (_ctx.modelType === 3)
                          ? (_openBlock(), _createBlock(_component_project_stage_display_item, {
                              key: 1,
                              modelValue: _ctx.theModel[index],
                              "onUpdate:modelValue": ($event: any) => ((_ctx.theModel[index]) = $event),
                              modelType: _ctx.modelType,
                              onOnDeleteClick: ($event: any) => (_ctx.deleteItem(index))
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "modelType", "onOnDeleteClick"]))
                          : (_ctx.modelType === 8)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _createVNode(_component_q_checkbox, {
                                  size: "sm",
                                  class: "q-pa-none",
                                  "toggle-indeterminate": "",
                                  "checked-icon": "arrow_forward_ios",
                                  "unchecked-icon": "arrow_back_ios",
                                  "indeterminate-icon": "drag_handle",
                                  "false-value": 2,
                                  "true-value": 1,
                                  color: "grey-7",
                                  "indeterminate-value": 0,
                                  modelValue: _ctx.theModel[index].CompareType,
                                  "onUpdate:modelValue": ($event: any) => ((_ctx.theModel[index].CompareType) = $event)
                                }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                                _createVNode(_component_native_input, {
                                  ref_for: true,
                                  ref: 'price_input',
                                  style: {"min-width":"100px"},
                                  "model-value": _ctx.theModel[index].Value,
                                  "input-type": "number",
                                  "show-border": true,
                                  "edit-on-click": true,
                                  "onUpdate:modelValue": 
                  (newprice) => {
                    _ctx.theModel[index].Value = +newprice
                  }
                
                                }, null, 8, ["model-value", "onUpdate:modelValue"])
                              ]))
                            : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ], 2),
                (![1,2,3,4,14].includes(_ctx.modelType))
                  ? (_openBlock(), _createBlock(_component_q_btn, {
                      key: 0,
                      class: _normalizeClass('q-px-none q-ml-xs'+(_ctx.modelType === 8 ? '' : ' unset-items-center')),
                      flat: "",
                      dense: "",
                      "aria-label": _ctx.$t('delete_filter'),
                      icon: "close",
                      size: "sm",
                      tabindex: "-1",
                      color: "accent",
                      onClick: ($event: any) => (_ctx.deleteItem(index))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_tooltip, {
                          delay: 300,
                          anchor: "top middle",
                          self: "center middle"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('remove')), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1032, ["class", "aria-label", "onClick"]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
      ], 2))
    }), 128))
  ], 2))
}